import { TrackAvailabilityOptionDto } from '@cratehackers/api-client';
import { IonButton, IonIcon } from '@ionic/react';
import { cartOutline, downloadOutline } from 'ionicons/icons';
import React from 'react';
import { openExternalLink } from '../../utils/openExternalLink';
import { useAssetIconPath } from '../../hooks/useAssetIconPath';
import {
  createAmazonAffiliateUrl,
  createBeatportAffiliateUrl,
  isBeatportUrl,
} from '../tracks/affiliateLinks';
import './TrackPurchaseDropdown.scss';

interface TrackPurchaseDropdownProps {
  artist: string;
  title: string;
  dropdownData: TrackAvailabilityOptionDto[];
}

export const TrackPurchaseDropdown: React.FC<TrackPurchaseDropdownProps> = ({
  artist,
  title,
  dropdownData = [],
}) => {
  const isAmazonOption = (item: TrackAvailabilityOptionDto) => {
    const rawUrl = JSON.stringify(item.url || '').replace(/"/g, '');
    return (
      rawUrl === 'https://www.amazon.com/s?k=' ||
      /amazon/i.test(item.name || '')
    );
  };

  const isBeatportOption = (item: TrackAvailabilityOptionDto) => {
    const rawUrl = JSON.stringify(item.url || '').replace(/"/g, '');
    return isBeatportUrl(rawUrl) || /beatport/i.test(item.name || '');
  };

  const otherStores = dropdownData.filter(
    (item) => !isAmazonOption(item) && !isBeatportOption(item),
  );

  const amazonUrl = createAmazonAffiliateUrl(artist, title);
  const beatportUrl = createBeatportAffiliateUrl(artist, title);
  const amazonLogoSrc = useAssetIconPath('amazon-logo.png');
  const beatportLogoSrc = useAssetIconPath('beatport-icon.png');

  return (
    <div className="purchase-dropdown-container">
      <div className="primary-purchase-actions">
        <IonButton
          className="track-view-download btn-beatport-brand"
          onClick={() => openExternalLink(beatportUrl)}
        >
          <div className="track-view-logo-beatport-container">
            <img src={beatportLogoSrc} alt="Beatport" />
          </div>
          Buy on Beatport{' '}
          <IonIcon style={{ margin: ' 0 5px 5px' }} icon={downloadOutline} />
        </IonButton>

        <IonButton
          className="track-view-download btn-amazon-brand"
          onClick={() => openExternalLink(amazonUrl)}
        >
          <div className="track-view-logo-container amazon-logo-container">
            <img src={amazonLogoSrc} alt="Amazon" />
          </div>
          Buy on Amazon{' '}
          <IonIcon style={{ margin: ' 0 5px 5px' }} icon={downloadOutline} />
        </IonButton>
      </div>

      {otherStores.length > 0 && (
        <div className="other-stores-section">
          <div className="other-stores-divider">
            <span className="divider-text">Other Stores</span>
          </div>
          <div className="other-stores-list">
            {otherStores.map((item, index) => {
              if (!item.url) return null;
              const itemUrl = `${item.url}${title} ${artist}`;
              return (
                <button
                  type="button"
                  key={index}
                  className="other-store-item"
                  onClick={() => openExternalLink(itemUrl)}
                >
                  <span className="store-name">{item.name}</span>
                  <IonIcon icon={cartOutline} className="store-icon" />
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
